import React from "react";
import Page from "../components/page";
import Layoute from "../components/layoute";
import {
  Button,
  Modal,
  Form,
  Input,
  Card,
  Select,
  AutoComplete,
  Dropdown,
  Spin,
  Tabs,
  Divider,
  Upload,
} from "antd";
import { Layout, Menu, Breadcrumb, Icon } from "antd";
import Demande from "../components/demande";
import News from "../components/news";
import Meeting from "../components/meeting";
import Calandar from "../components/calandar";
import Table from "../components/table";
import Emailing from "../components/emailing";
import FileShare from "../components/file-share";
import Logs from "../components/logs";
import Facturation from "../components/facturation";
import AdminSettings from "../components/admin-settings";

import moment from "moment";

const { Header, Content, Footer, Sider } = Layout;
const SubMenu = Menu.SubMenu;
const { TextArea } = Input;
const TabPane = Tabs.TabPane;

class Dashboard extends Page {
  constructor(props) {
    super(props);
    this.state = {
      key: props.key || 1,
      collapsed: false,
      ModalText: "Content of the modal",
      visible: false,
      confirmLoading: false,
      user: props.user,
      loading: true,
      fileList: [],
      adhereVisible: false,
    };
  }

  onCollapse = (collapsed) => {
    console.log(collapsed);
    this.setState({ collapsed });
  };

  componentWillMount() {
    if (typeof document !== "undefined") {
      if (
        Math.max(document.documentElement.clientWidth, window.innerWidth || 0) <
        427
      ) {
        this.setState({
          collapsed: true,
        });
      }
    }
  }

  componentDidMount() {
    fetch("/api/auth/token", {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: localStorage.getItem("x-access-token"),
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.user) {
          window.location.href = "/login";
        } else {
          localStorage.setItem("user", JSON.stringify(res.user));
          // Replace old oversized tokens with the compact refreshed one
          if (res.token) localStorage.setItem("x-access-token", res.token);
          this.setState({
            user: res.user,
            tmpUser: res.user,
            loading: false,
          });
        }
      });
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    let formData = new FormData();

    Object.keys(this.state.tmpUser).map((m) => {
      if (m !== "group") {
        formData.append(m, JSON.stringify(this.state.tmpUser[m]));
      }
    });

    if (this.state.fileList.length > 0) {
      formData.append("logo", this.state.fileList[0]);
    }

    fetch("/api/user", {
      credentials: "include",
      method: "PUT",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          user: this.state.tmpUser,
          visible: false,
        });
      });
  };

  handleCancel = () => {
    this.setState({
      tmpUser: this.state.user,
      visible: false,
      fileList: [],
    });
  };

  logOut() {
    localStorage.clear();
    window.location.href = "/login";
  }

  onRemove(file) {
    this.setState({
      fileList: [],
      preview: "",
    });
  }

  beforeUpload(file) {
    var fr = new FileReader();
    fr.onload = () => {
      this.setState({
        preview: fr.result,
      });
    };
    fr.readAsDataURL(file);

    this.setState({
      fileList: [file],
    });

    return false;
  }

  render() {
    const { visible, confirmLoading, ModalText } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { autoCompleteResult } = this.state;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const menu = (
      <Menu>
        <Menu.Item>
          <a onClick={() => this.showModal()} className="dropdown-link-nav">
            <Icon type="form" />
            <a>Modifier mes informations</a>
          </a>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <a className="dropdown-link-nav" onClick={() => this.logOut()}>
            <Icon style={{ color: "#d94328" }} type="logout" />
            <a style={{ color: "#d94328" }}>Déconnexion</a>
          </a>
        </Menu.Item>
      </Menu>
    );

    return (
      <Layoute {...this.props} hidden={true}>
        {this.state.loading ? (
          <div
            style={{
              height: "100vh",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Spin size="large" />
            <b style={{ marginTop: "10px" }}>Connexion au portail ...</b>
          </div>
        ) : (
          <Layout style={{ minHeight: "100vh" }} hasSider={true}>
            <Sider
              collapsible
              collapsed={this.state.collapsed}
              onCollapse={this.onCollapse}
            >
              {this.state.collapsed == false ? (
                <div className="logo" />
              ) : (
                <div className="smallLogo"></div>
              )}
              <Menu
                theme="dark"
                defaultSelectedKeys={["1"]}
                mode="inline"
                onClick={(item, key, path) => {
                  this.setState({ key: item.key });
                }}
              >
                <Menu.Item key="1">
                  <Icon type="calendar" />
                  <span className="menuLink">Calendrier</span>
                </Menu.Item>
                {(this.state.user && this.state.user.admin) ||
                (this.state.user &&
                  this.state.user.group.findIndex((f) => {
                    return f.slug == "membre-du-bureau";
                  }) !== -1) ? (
                  <Menu.Item key="2">
                    <Icon type="desktop" />
                    <span className="menuLink">Adhésion</span>
                  </Menu.Item>
                ) : (
                  ""
                )}
                <SubMenu
                  key="sub1"
                  title={
                    <span>
                      <Icon type="user" />
                      <span>Demandes</span>
                    </span>
                  }
                >
                  <Menu.Item key="3">Actualités</Menu.Item>
                  <Menu.Item key="4">Evenements</Menu.Item>
                </SubMenu>
                {(this.state.user && this.state.user.admin) ||
                (this.state.user &&
                  this.state.user.group.findIndex((f) => {
                    return f.slug == "membre-du-bureau";
                  }) !== -1)
                  ? [
                      <Menu.Item key="5">
                        <Icon type="team" />
                        <span>Entreprises</span>
                      </Menu.Item>,
                      <Menu.Item key="8">
                        <Icon type="mail" />
                        <span>Emailing</span>
                      </Menu.Item>,
                      <Menu.Item key="9">
                        <Icon type="file" />
                        <span>Partage de fichiers</span>
                      </Menu.Item>,
                      <Menu.Item key="10">
                        <Icon type="solution" />
                        <span>Historique</span>
                      </Menu.Item>,
                      <Menu.Item key="11">
                        <Icon type="database" />
                        <span>Facturation</span>
                      </Menu.Item>,
                      <Menu.Item key="12">
                        <Icon type="setting" />
                        <span>Paramètres</span>
                      </Menu.Item>,
                    ]
                  : ""}
              </Menu>
            </Sider>
            <Layout>
              <Header style={{ background: "#fff", padding: 0 }}>
                <div className="header">
                  <div className="left">
                    {this.state.key == 1 ? "Calendrier Le Hub Bezannes" : null}
                    {this.state.key == 2
                      ? "Demandes d'adhésion à l'association"
                      : null}
                    {this.state.key == 3 ? "Proposition d'actualités" : null}
                    {this.state.key == 4 ? "Proposition d'évenements" : null}
                    {this.state.key == 12 ? "Paramètres administrateur" : null}
                  </div>
                  {this.state.user && this.state.user.firstname ? (
                    <div
                      style={{ position: "absolute", right: "10px", top: "0" }}
                      className="right"
                    >
                      <div className="init">
                        {this.state.user && this.state.user.firstname
                          ? this.state.user.firstname.substring(0, 1) +
                            this.state.user.lastname.substring(0, 1)
                          : ""}
                      </div>
                      <Dropdown trigger={["click"]} overlay={menu}>
                        <div
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          className="top"
                        >
                          <span>
                            {this.state.user && this.state.user.firstname
                              ? this.state.user.firstname
                              : ""}{" "}
                            {this.state.user && this.state.user.lastname
                              ? this.state.user.lastname
                              : ""}
                          </span>
                        </div>
                      </Dropdown>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Header>
              <Content style={{ margin: "0 16px" }}>
                <Breadcrumb style={{ margin: "16px 0" }}>
                  <Breadcrumb.Item>{this.state.name}</Breadcrumb.Item>
                </Breadcrumb>
                <div
                  className="content"
                  style={{
                    padding: 24,
                    display: "flex",
                    flexDirection: "column",
                    background: "#fff",
                    minHeight: "80vh",
                  }}
                >
                  {this.state.key == 1 ? (
                    <Calandar user={this.state.user} />
                  ) : null}
                  {this.state.key == 2 ? <Demande /> : null}
                  {this.state.key == 3 ? (
                    <News
                      adModal={() => this.setState({ adhereVisible: true })}
                      user={this.state.user}
                    />
                  ) : null}
                  {this.state.key == 4 ? (
                    <Meeting
                      adModal={() => this.setState({ adhereVisible: true })}
                      user={this.state.user}
                    />
                  ) : null}
                  {this.state.key == 5 ? (
                    <Table user={this.state.user} />
                  ) : null}
                  {this.state.key == 8 ? <Emailing /> : null}
                  {this.state.key == 9 ? <FileShare /> : null}
                  {this.state.key == 10 ? <Logs /> : null}
                  {this.state.key == 11 ? <Facturation /> : null}
                  {this.state.key == 12 ? (
                    <AdminSettings user={this.state.user} />
                  ) : null}
                </div>
              </Content>
              <Footer style={{ textAlign: "center" }}>
                Tous droits réservés - Le Hub Bezannes {moment().format("YYYY")} -{" "}
                <a
                  target="_blank"
                  href="https://le-hub-bezannes.fr/mentions-legales/"
                >
                  Mentions légales
                </a>
              </Footer>
            </Layout>
          </Layout>
        )}

        <Modal
          title="Adhérer à l'association"
          visible={this.state.adhereVisible}
          onOk={() => {
            this.setState({ adhereVisible: false });
          }}
          onCancel={() => {
            this.setState({ adhereVisible: false });
          }}
          cancelText="Annuler"
          width={1100}
          className="adherer-modal"
        >
          Pour consulter les tarifs et les modalités d'adhésion à jour,&nbsp;
          <a
            href="https://le-hub-bezannes.fr/adhesion-tarifs/"
            target="_blank"
            rel="noopener noreferrer"
          >
            consultez la page dédiée
          </a>
          .
          <br />
          <br />
          Si vous souhaitez adhérer à l'association, merci d'effectuer votre
          réglement par virement sur le compte crédit agricole&nbsp;
          <b>IBAN FR76 1020 6511 6498 7138 5745 995</b>
          <br /> Ou éventuellement par chèque à l'ordre de&nbsp;
          <b>APAR BEZANNES</b>
          &nbsp;et à envoyer à l'adresse : 1 rue Source de Muire, 51430 Bezannes
          <br />
          <br /> Une fois votre demande d'adhésion acceptée et le réglement
          effectué, vous recevrez un email vous confirmant votre adhésion à
          l'association
          <br /> Vous pourrez profiter des avantages des membres actifs sur le
          portail : Publication d'actualités et d'évènements lié à votre entité,
          présence sur l'annuaire, référencement ...
          <br />
          <br />
          <div className="logo"></div>
          <i>Les membres du bureau</i>
        </Modal>

        {this.state.user ? (
          <Modal
            title="Modification du profil"
            visible={visible}
            onOk={this.handleOk}
            cancelText="Annuler"
            confirmLoading={confirmLoading}
            onCancel={this.handleCancel}
            width={1100}
          >
            <Tabs defaultActiveKey="1">
              <TabPane tab="Compte utilisateur" key="1">
                <Form>
                  <div className="form-item">
                    <p>Nom</p>
                    <Input
                      value={this.state.tmpUser.lastname}
                      onChange={(e) =>
                        this.setState({
                          tmpUser: {
                            ...this.state.tmpUser,
                            lastname: e.target.value,
                          },
                        })
                      }
                      type="text"
                    />
                  </div>
                  <div className="form-item">
                    <p>Prénom</p>
                    <Input
                      value={this.state.tmpUser.firstname}
                      onChange={(e) =>
                        this.setState({
                          tmpUser: {
                            ...this.state.tmpUser,
                            firstname: e.target.value,
                          },
                        })
                      }
                      type="text"
                    />
                  </div>
                  <div className="form-item">
                    <p>Email</p>
                    <Input
                      value={this.state.tmpUser.email}
                      onChange={(e) =>
                        this.setState({
                          tmpUser: {
                            ...this.state.tmpUser,
                            email: e.target.value,
                          },
                        })
                      }
                      type="text"
                    />
                  </div>
                  <div className="form-item">
                    <p>Téléphone portable</p>
                    <Input
                      value={
                        this.state.tmpUser.phone &&
                        this.state.tmpUser.phone.port
                      }
                      onChange={(e) =>
                        this.setState({
                          tmpUser: {
                            ...this.state.tmpUser,
                            phone: {
                              ...this.state.tmpUser.phone,
                              port: e.target.value,
                            },
                          },
                        })
                      }
                      type="text"
                    />
                  </div>
                  <div className="form-item">
                    <p>Téléphone fixe</p>
                    <Input
                      value={
                        this.state.tmpUser.phone &&
                        this.state.tmpUser.phone.fixe
                      }
                      onChange={(e) =>
                        this.setState({
                          tmpUser: {
                            ...this.state.tmpUser,
                            phone: {
                              ...this.state.tmpUser.phone,
                              fixe: e.target.value,
                            },
                          },
                        })
                      }
                      type="text"
                    />
                  </div>
                </Form>
              </TabPane>
              <TabPane tab="Fiche société" key="2">
                <Form className="form-profile">
                  <div className="col">
                    <div className="infos">
                      <h5>Informations</h5>
                      <div className="form-item">
                        <p>Nom</p>
                        <Input
                          value={this.state.tmpUser.company.name}
                          onChange={(e) =>
                            this.setState({
                              tmpUser: {
                                ...this.state.tmpUser,
                                company: {
                                  ...this.state.tmpUser.company,
                                  name: e.target.value,
                                },
                              },
                            })
                          }
                          type="text"
                        />
                      </div>
                      <div className="form-item">
                        <p>Adresse</p>
                        <Input
                          value={this.state.tmpUser.company.address}
                          onChange={(e) =>
                            this.setState({
                              tmpUser: {
                                ...this.state.tmpUser,
                                company: {
                                  ...this.state.tmpUser.company,
                                  address: e.target.value,
                                },
                              },
                            })
                          }
                          type="text"
                        />
                      </div>
                      <div className="form-item">
                        <p>Ville</p>
                        <Input
                          value={this.state.tmpUser.company.city}
                          onChange={(e) =>
                            this.setState({
                              tmpUser: {
                                ...this.state.tmpUser,
                                company: {
                                  ...this.state.tmpUser.company,
                                  city: e.target.value,
                                },
                              },
                            })
                          }
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="contact">
                      <h5>Contact</h5>
                      <div className="form-item">
                        <p>Email de contact</p>
                        <Input
                          value={this.state.tmpUser.company.contact}
                          onChange={(e) =>
                            this.setState({
                              tmpUser: {
                                ...this.state.tmpUser,
                                company: {
                                  ...this.state.tmpUser.company,
                                  contact: e.target.value,
                                },
                              },
                            })
                          }
                          type="text"
                        />
                      </div>
                      <div className="form-item">
                        <p>Téléphone</p>
                        <Input
                          value={this.state.tmpUser.company.phone}
                          onChange={(e) =>
                            this.setState({
                              tmpUser: {
                                ...this.state.tmpUser,
                                company: {
                                  ...this.state.tmpUser.company,
                                  phone: e.target.value,
                                },
                              },
                            })
                          }
                          type="text"
                        />
                      </div>
                      <div className="form-item">
                        <p>Site internet</p>
                        <Input
                          value={this.state.tmpUser.company.website}
                          onChange={(e) =>
                            this.setState({
                              tmpUser: {
                                ...this.state.tmpUser,
                                company: {
                                  ...this.state.tmpUser.company,
                                  website: e.target.value,
                                },
                              },
                            })
                          }
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="details">
                    <div className="col">
                      <h5>Détails</h5>
                      <div className="form-item">
                        <p>Description</p>
                        <TextArea
                          rows="5"
                          value={this.state.tmpUser.company.infos}
                          onChange={(e) =>
                            this.setState({
                              tmpUser: {
                                ...this.state.tmpUser,
                                company: {
                                  ...this.state.tmpUser.company,
                                  infos: e.target.value,
                                },
                              },
                            })
                          }
                        ></TextArea>
                      </div>
                      <div className="form-item">
                        <p>Facebook</p>
                        <Input
                          placeholder="https://facebook.com/page_facebook"
                          value={this.state.tmpUser.company.facebook}
                          onChange={(e) =>
                            this.setState({
                              tmpUser: {
                                ...this.state.tmpUser,
                                company: {
                                  ...this.state.tmpUser.company,
                                  facebook: e.target.value,
                                },
                              },
                            })
                          }
                          type="text"
                        />
                      </div>
                      <div className="form-item">
                        <p>Twitter</p>
                        <Input
                          placeholder="https://twitter.com/compte_twitter"
                          value={this.state.tmpUser.company.twitter}
                          onChange={(e) =>
                            this.setState({
                              tmpUser: {
                                ...this.state.tmpUser,
                                company: {
                                  ...this.state.tmpUser.company,
                                  twitter: e.target.value,
                                },
                              },
                            })
                          }
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="col logo-holder">
                      {this.state.tmpUser.company.logo ? (
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "15px",
                            boderRadius: "5px",
                            border: "1px dashed #d8d8d8",
                            borderBottom: 0,
                          }}
                        >
                          <img
                            width="100"
                            src={
                              this.state.fileList.length == 0
                                ? this.state.tmpUser.company.logo
                                : this.state.preview
                            }
                            alt=""
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      <div
                        className="upload-btn"
                        style={{ marginTop: "5px", width: "100%" }}
                        label="Logo"
                      >
                        <Upload
                          style={{ width: "100%" }}
                          fileList={this.state.fileList}
                          onRemove={(file) => this.onRemove(file)}
                          beforeUpload={(file) => this.beforeUpload(file)}
                          name="logo"
                        >
                          <Button
                            style={{
                              width: "100%",
                              borderRadius: 0,
                              marginTop: 0,
                            }}
                          >
                            <Icon type="upload" /> Sélectionner le logo de la
                            société
                          </Button>
                        </Upload>
                      </div>
                    </div>
                  </div>
                </Form>
              </TabPane>
            </Tabs>
          </Modal>
        ) : (
          ""
        )}
      </Layoute>
    );
  }
}

export default Form.create()(Dashboard);



// WEBPACK FOOTER //
// ./pages/dashboard.js